  <template>
  <div>
    <div
      class="modal fade"
      id="modalLog"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalLog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title" id="exampleModalLabel">
              Log de transacciones <i class="fas fa-history"></i>
            </h6>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div style="overflow-y: scroll; max-height: 475px" class="modal-body">
            <table class="table table-striped table-bordered table-hover">
              <thead>
                <tr>
                  <th style="color: green" class="text-center">Operación</th>
                  <th style="color: green" class="text-center">datos</th>
                  <th style="color: green" class="text-center">
                    Error Operación
                  </th>
                  <th style="color: green" class="text-center">Fecha</th>
                  <th style="color: green" class="text-center">User</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="current in logs" v-bind:key="current.id">
                  <td
                    style="color: blue; width: 30px"
                    class="text-center font-weight-bold"
                  >
                    {{ current.descripcion }}
                  </td>
                  <td class="text-left" style="width: 100px; color: black">
                    {{ current.datos }}
                  </td>
                  <td
                    class="text-danger font-weight-bold"
                    style="width: 50px; color: black"
                  >
                    {{ current.error_devuelto }}
                  </td>
                  <td class="text-center" style="color: black">
                    {{ current.fecha_creacion | moment("DD/MM/YYYY HH:MM:ss") }}
                  </td>
                  <td class="text-center" style="color: black">
                    {{ current.usuario_id }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-info" data-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";

export default {
  props: {
    modulo: {
      type: String,
      required: true,
    },
    transac: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      logs: "",
    };
  },
  watch: {
    id: function () {
      this.RefreshData();
    },
  },
  computed: {},
  mounted() {
    this.RefreshData();
  },
  methods: {
    RefreshData() {
      DynamicService.postAction(
        this.modulo,
        this.transac,
        this.id,
        "api_log_oasis"
      ).then((response) => {
        this.logs = response.data;
      });
    },
  },
};
</script>
